/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./previewerSwitcher.vue?vue&type=template&id=180badf2&scoped=true&"
import script from "./previewerSwitcher.vue?vue&type=script&lang=js&"
export * from "./previewerSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./previewerSwitcher.vue?vue&type=style&index=0&id=180badf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180badf2",
  null
  
)

export default component.exports